import { useEffect } from "react";
import { useBlocker, useNavigate } from "react-router-dom";

import {
  buildRedirectTarget,
  getLoginPathWithRedirect,
  isAuthenticated,
  isLoginPath,
  isProtectedPath,
} from "helpers/authSession";
import routes from "constants/routes";

const isHomePath = (pathname) => pathname === routes.coupons.list;

const useAppNavigationGuards = () => {
  const navigate = useNavigate();

  const blocker = useBlocker(({ currentLocation, nextLocation, historyAction }) => {
    const currentPath = currentLocation.pathname;
    const nextPath = nextLocation.pathname;
    const userIsAuthenticated = isAuthenticated();

    if (isHomePath(currentPath) && historyAction === "POP") {
      return true;
    }

    if (
      userIsAuthenticated &&
      isLoginPath(nextPath) &&
      historyAction !== "REPLACE"
    ) {
      return true;
    }

    if (!userIsAuthenticated && isProtectedPath(nextPath)) {
      return true;
    }

    return false;
  });

  useEffect(() => {
    if (blocker.state !== "blocked") {
      return;
    }

    const nextPath = blocker.location?.pathname;
    const nextSearch = blocker.location?.search ?? "";
    const userIsAuthenticated = isAuthenticated();

    if (userIsAuthenticated && isLoginPath(nextPath)) {
      blocker.reset();
      navigate(routes.coupons.list, { replace: true });
      return;
    }

    if (!userIsAuthenticated && nextPath && isProtectedPath(nextPath)) {
      blocker.reset();
      navigate(
        getLoginPathWithRedirect(buildRedirectTarget(nextPath, nextSearch)),
        { replace: true }
      );
      return;
    }

    blocker.reset();
  }, [blocker, navigate]);
};

export default useAppNavigationGuards;
